module.exports = __webpack_public_path__ + "static/media/team-swimmy-raphaelle.96ab5cc7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/team-swimmy-raphaelle.png
// module id = 2508
// module chunks = 0